/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */

export type FsmSyncItemMetadataDtoKind = typeof FsmSyncItemMetadataDtoKind[keyof typeof FsmSyncItemMetadataDtoKind];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const FsmSyncItemMetadataDtoKind = {
  fsmSync: 'fsmSync',
} as const;
